import styled from "styled-components";
import newsSrc from "../../assets/images/bg-news-home.jpeg"

export function Newsletter() {
  return (
    <Content>
      <News>
        <Form>
          <Title>Assine nossa newsletter</Title>
          <Subtitle>Fique sempre por dentro das nossas atividades. Assine <br /> e receba diretamente na sua caixa de email.</Subtitle>
          <Input type="email" placeholder="Digite seu email" />
          <Button>Assinar</Button>
        </Form>
      </News>
    </Content>
  );
}

const Content = styled.div`
  height: 580px;
  background-image: url(${newsSrc});
  background-size: cover;
  position: relative;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    height: 480px;
  }
`;

const News = styled.div`
  width: 472px;
  background-color: ${({ theme }) => theme?.colors?.blue.dark};
  color: #fff;
  padding: 22px 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: calc(100% - 28px);
  }
`;

const Form = styled.form``;

const Title = styled.span`
  display: block;
  font-size: 28px;
  text-transform: uppercase;
  margin-bottom: 6px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 22px;
  }
`;

const Subtitle = styled.span`
  display: block;
  font-size: 13px;
  line-height: 1.5;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 12px;
  }
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  margin: 24px 0 40px;
  padding: 0 12px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    margin-bottom: 24px;
  }
`;

const Button = styled.button`
  width: 130px;
  height: 40px;
  padding: 0;
  border: none;
  background: #fff;
  color: ${({ theme }) => theme.colors.black.medium};
  text-transform: uppercase;
  cursor: pointer;
`;